export default "__VITE_ASSET__ecc51a30__"